import React, { memo } from 'react';
import { useWtrSelector } from 'redux/hooks';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { hasSubItems } from 'redux/modules/trolley/selectors/get-item-sub-products';
import getIsLoadingSubs from 'redux/modules/trolley/selectors/get-loading-subs';
import SubProductPod from '../SubProductPod';
import styles from './index.scss';

interface UnavailableProductProps {
  lineNumber?: string | null;
  trolleyItemId?: number | null;
  isProductRemovable?: boolean;
}

const UnavailableProduct = ({
  lineNumber = null,
  trolleyItemId = null,
  isProductRemovable = true,
}: UnavailableProductProps) => {
  // @ts-expect-error trolley state is not typed
  const hasSubs = useWtrSelector(state => hasSubItems(state, lineNumber));
  const isLoadingSubs = useWtrSelector(getIsLoadingSubs);
  return (
    <section>
      <header className={styles.header}>
        <Typography element="h2" styleAs="paragraphHeading">
          Unavailable Item
        </Typography>
      </header>
      <ul className={styles.list}>
        <SubProductPod
          // @ts-expect-error untyped component
          lineNumber={lineNumber}
          isUnavailable
          isRemovable={isProductRemovable && !hasSubs && !isLoadingSubs}
          // @ts-expect-error untyped component
          trolleyItemId={trolleyItemId}
        />
      </ul>
    </section>
  );
};

UnavailableProduct.displayName = 'UnavailableProduct';

export default memo(UnavailableProduct);
